import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { Icon } from '@icp/components';
import NodeContent from '../NodeContent';
import NodeRenderer from '../NodeRenderer';
import { useEntity, useEvents } from '../NodeContextProvider';
import { makeNewConditionBranch } from '../utils';
import NodeSpacer from '../NodeSpacer';

function ConditionNode(props) {
  const { keyPath, branches } = props;

  const { t } = useTranslation(['icp-flow']);

  const { onAddBranch } = useEvents();
  const entityFields = useEntity().fields;

  const handleAddBranch = () => {
    onAddBranch(keyPath, makeNewConditionBranch());
  };

  const filterName = (condition, value) => {
    const hideValue =
      condition === 'is_true' ||
      condition === 'is_not_true' ||
      condition === 'is_present' ||
      condition === 'is_not_present';
    const hasInterpolation = [
      'starts_with',
      'doesnot_start_with',
      'ends_with',
      'doesnot_end_with',
    ].includes(condition);

    return (
      <span className="condition-condition">
        {hasInterpolation ? (
          <Trans
            i18nKey={`if.interpolation.${condition}`}
            t={t}
            values={{ value: value || '' }}
            components={[<span className="condition-value" />]}
          />
        ) : (
          <>
            {t(`if.conditions.${condition}`)}
            {!hideValue ? <span className="condition-value">{value || ''}</span> : null}
          </>
        )}
      </span>
    );
  };

  return (
    <div className="icp-workflow-node condition-node">
      <div style={{ position: 'relative' }}>
        <button
          className="icp-workflow-add-button add-branch-button icp-action-button"
          onClick={handleAddBranch}
        >
          <Icon name="material:add-rounded" size={16} />
        </button>
      </div>
      <div className="condition-node-branches">
        {(branches || []).map((branch, index) => {
          const { operator, conditions, subFlow } = branch;
          const validConditions = (conditions || []).filter(
            (item) => item.dataField && item.condition,
          );
          const currentKeyPath = keyPath.concat('branches', index);
          const nextKeyPath = currentKeyPath.concat('subFlow');
          return (
            <div key={index} className="condition-node-branch">
              <NodeSpacer />
              <NodeContent
                {...props}
                id={branch.id}
                keyPath={currentKeyPath}
                className="condition-node-content"
                isBranch={true}
              >
                {Array.isArray(validConditions) && validConditions.length
                  ? validConditions.map((item, i) => {
                      const field = entityFields.find((x) => x.token === item.dataField) || {};
                      return (
                        <div key={item.id ?? i} className="condition-line">
                          {i === 0 ? (
                            <span className="step-statement">{t('if.title')}</span>
                          ) : (
                            <span className="step-statement">
                              {operator === 'AND' ? t('if.operator.and') : t('if.operator.or')}
                            </span>
                          )}
                          <span className="condition-field">{field.name || item.dataField}</span>
                          {filterName(item.condition, item.value)}
                        </div>
                      );
                    })
                  : t('if.set-condition')}
              </NodeContent>
              <NodeRenderer keyPath={nextKeyPath} nodeList={subFlow} />
            </div>
          );
        })}
      </div>
    </div>
  );
}

ConditionNode.propTypes = {
  keyPath: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  branches: PropTypes.arrayOf(PropTypes.shape({})),
};

export default ConditionNode;
